import { SurveyCreator } from "survey-creator-react";

export const creatorConfig = {
	showThemeTab: false,
	showCreatorThemeSettings: false,
	showJSONEditorTab: false,
	showLogicTab: false,
	previewAllowSimulateDevices: false,
};

export const customTheme = {
	themeName: "bottoli",
	cssVariables: {
		"--sjs-layer-1-background-500": "#FFFFFFFF",
		"--sjs-layer-1-background-400": "#FFFFFFFF",
		"--sjs-layer-1-foreground-100": "#122243FF",
		"--sjs-layer-1-foreground-50": "#0E205580",
		"--sjs-layer-3-background-500": "#FFFFFFFF",
		"--sjs-layer-3-foreground-100": "#273859FF",
		"--sjs-layer-3-foreground-50": "#26335880",
		"--sjs-layer-2-background-500": "#FFFFFFFF",
		"--sjs-layer-2-background-400": "#FFFFFFFF",
		"--sjs-special-haze": "#3189EC40",
		"--sjs-border-25": "#3189EC20",
		"--sjs-border-10": "#3189EC15",
		"--sjs-primary-background-500": "#3189ECFF",
		"--sjs-primary-background-10": "#3189EC1A",
		"--sjs-primary-background-400": "#2070D6FF",
		"--sjs-primary-foreground-100": "#FFFFFFFF",
		"--sjs-primary-foreground-25": "#FFFFFF40",
		"--sjs-secondary-background-500": "#3189ECFF",
		"--sjs-secondary-background-25": "#3189EC40",
		"--sjs-secondary-background-10": "#3189EC1A",
		"--sjs-secondary-foreground-100": "#FFFFFFFF",
		"--sjs-secondary-forecolor-25": "#FFFFFF40",
		"--sjs-semantic-red-background-500": "#D6378AFF",
		"--sjs-semantic-red-background-10": "#D6378A1A",
		"--sjs-semantic-red-foreground-100": "#FFFFFFFF",
		"--sjs-semantic-green-background-500": "#19B394FF",
		"--sjs-semantic-green-background-10": "#19B3941A",
		"--sjs-semantic-green-foreground-100": "#FFFFFFFF",
		"--sjs-semantic-blue-background-500": "#3189ECFF",
		"--sjs-semantic-blue-background-10": "#3189EC1A",
		"--sjs-semantic-blue-foreground-100": "#FFFFFFFF",
		"--sjs-semantic-yellow-background-500": "#FF9814FF",
		"--sjs-semantic-yellow-background-10": "#FF98141A",
		"--sjs-semantic-yellow-foreground-100": "#FFFFFFFF",
		"--sjs-semantic-white-background-500": "#FFFFFFFF",
		"--sjs-code-gray-700": "#B6B6B6FF",
		"--sjs-code-blue-500": "#3189ECFF",
		"--sjs-code-gray-300": "#505050FF",
		"--sjs-code-green-500": "#08997CFF",
		"--sjs-code-red-500": "#F41B50FF",
		"--sjs-code-purple-500": "#C22FA2FF",
		"--sjs-code-yellow-500": "#F58D06FF",
		"--sjs-code-gray-500": "#8A8A8AFF",
		"--sjs-special-background": "#FFFFFFFF",
		"--sjs-layer-1-foreground-75": "#3189ECFF",
		"--sjs-layer-3-background-400": "#FFFFFFFF",
		"--sjs-special-glow": "#3189EC33",
		"--sjs-special-shadow": "#3189EC40",
		"--sjs-layer-3-foreground-75": "#3189ECFF",
		"--sjs-layer-2-foreground-100": "#273859FF",
		"--sjs-layer-2-foreground-75": "#3189ECFF",
		"--sjs-layer-2-foreground-50": "#26335880",
		"--sjs-border-25-overlay": "#00000026",
		"--sjs-secondary-background-400": "#2070D6FF",
		"--sjs-primary-backcolor": "#3189EC",
	},
};

// const defaultSurveyConfig = {
// 	pages: [
// 		{
// 			name: "Pagina 1",
// 			elements: [
// 				{
// 					type: "text",
// 					name: "esempio_campo",
// 					title: "Campo di esempio",
// 					isRequired: false,
// 				},
// 			],
// 		},
// 	],
// };
